import { LexicalEditor, LexicalNode, SerializedEditor, createEditor } from "lexical";
import { Decorable, GConstructor } from "./general";

export interface NestedEditorPayload {
  nestedEditor: LexicalEditor;
}

export interface NestedEditorMixinPayload {
  __nestedEditor: LexicalEditor;
}

export type SerializedNestedEditor = {
  nestedEditor: SerializedEditor;
};

type NestedEditorCtor = GConstructor<Decorable & NestedEditorMixinPayload>;

export function NestedEditorMixin<TBase extends NestedEditorCtor>(Base: TBase) {
  return class NestedEditor extends Base {
    __nestedEditor!: LexicalEditor;

    constructor(...args: any[]) {
      const [nestedEditor, ...rest] = args;
      super(...rest);
      this.__nestedEditor = nestedEditor || createEditor();
    }

    exportNestedEditor(): SerializedNestedEditor {
      const self = this.getLatest();
      return {
        nestedEditor: self.__nestedEditor.toJSON(),
      };
    }

    getEditor() {
      const self = this.getLatest();
      return self.__nestedEditor;
    }

    setEditor(nestedEditor: LexicalEditor) {
      const self = this.getWritable();
      self.__nestedEditor = nestedEditor;
    }
  };
}